import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { UpdateMeRequestModel } from '@xver/apis/v1/users/model';
import { useAppDispatch } from '@xver/hooks/useAppDispatch';
import { ME_QUERY_KEY } from '@xver/hooks/useMeQuery';
import { getErrorMessage } from '@xver/utils/error';
import { setAuthUser } from '@xver/store/auth/auth.actions';
import { useTranslation } from 'react-i18next';

export function useUpdateProfileMutation() {
    const { t } = useTranslation('profile');
    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();

    return useMutation({
        mutationFn: (payload: UpdateMeRequestModel) => Endpoints.v1.Users.updateMe(payload),
        onSuccess: async (response) => {
            notifications.show({
                title: t('toast.saveTitle'),
                message: response?.message ?? t('toast.saveMessage'),
                icon: <IconCheck size={18} color="#22c55e" />,
            });
            dispatch(setAuthUser(response.data));
            await queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
        },
        onError: (err: unknown) => {
            notifications.show({
                title: t('toast.errorTitle'),
                message: getErrorMessage(err) ?? t('toast.errorMessage'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
